import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentage'
})
export class PercentagePipe implements PipeTransform {
  transform(value: unknown, fractionDigits = 0): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    else if (typeof value === 'string' && value) {
      return value.includes('%') ? value : value + '%';
    }
    else if (typeof value === 'number' && !Number.isFinite(value)) {
      return '';
    }
    else if (typeof value === 'number' && fractionDigits === 0) {
      return value.toFixed(fractionDigits) + '%';
    }
    else if (typeof value === 'number' && fractionDigits > 0) {
      const str = value.toFixed(fractionDigits).replace(/0+$/, ''); // trim ending zeros
      const zeroFraction = (0).toFixed(fractionDigits).substring(1); // take fraction part including delimiter (for example, in US locale: ".123")
      const percentage = str.endsWith(zeroFraction) ? str.substring(0, str.length - zeroFraction.length) : str;
      return percentage + '%';

    }
    else {
      return String(value);
    }
  }
}
